<ul>
  <li *ngFor="let item of inner_Chart" class="MyMoeinListCat_Li">

    <div class="MyMoeinListCat_Div">
      <span class="MyMoeinListCat_Span">{{item.title}}</span>

      <i *ngIf="!item.childVisible" class="fa fa-times-rectangle" style="visibility: visible !important;color: red;" (click)="Change_Visible(item)"></i>
      <i *ngIf="item.childVisible" class="fa  fa-check-square" style="visibility: visible !important;color: green" (click)="Change_Visible(item)"></i>


    </div>


    <app-Chart_Check_Co
      (On_Change_Action)="Change_Visible($event)"
      [inner_Chart]="item.child">

    </app-Chart_Check_Co>



  </li>
</ul>
